module.exports = __webpack_public_path__ + "img/edelstahlarbeiten.a94fc16d.webp";